export default "__VITE_ASSET__oGh8LnrH__"